"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "getCacheDataDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.getCacheDataDecorator;
  }
});
Object.defineProperty(exports, "getCacheDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.getCacheDecorator;
  }
});
Object.defineProperty(exports, "getConfirmDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.getConfirmDecorator;
  }
});
Object.defineProperty(exports, "getLoadingDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.getLoadingDecorator;
  }
});
Object.defineProperty(exports, "getMessageDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.getMessageDecorator;
  }
});
Object.defineProperty(exports, "getMockDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.getMockDecorator;
  }
});
Object.defineProperty(exports, "getPromptDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.getPromptDecorator;
  }
});
Object.defineProperty(exports, "setDelayDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.setDelayDecorator;
  }
});
Object.defineProperty(exports, "setExtraExtensionParameterDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.setExtraExtensionParameterDecorator;
  }
});
Object.defineProperty(exports, "setRequestConfigDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.setRequestConfigDecorator;
  }
});
Object.defineProperty(exports, "setRequestHeaderDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.setRequestHeaderDecorator;
  }
});
Object.defineProperty(exports, "setRequestLogDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.setRequestLogDecorator;
  }
});
Object.defineProperty(exports, "setResponseComposeDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.setResponseComposeDecorator;
  }
});
Object.defineProperty(exports, "setResponseDataDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.setResponseDataDecorator;
  }
});
Object.defineProperty(exports, "setResponsePipeDecorator", {
  enumerable: true,
  get: function get() {
    return _apply.setResponsePipeDecorator;
  }
});
var _core = require("./core");
var _apply = require("./apply");
var _default = _core.createDecorator;
exports["default"] = _default;